import React from "react";
import { useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../context/Context.Language";
import {
  TEXT_AND_WORD,
  TEXT_AN_ORDER_NOW_2,
  TEXT_BANGKOK,
  TEXT_BKK_AND_PTY,
  TEXT_CONTACT_US,
  TEXT_CREATE,
  TEXT_FAQ_HAVE_MORE_QUESTIONS,
  TEXT_FAQ_HAVE_MORE_QUESTIONS_BKK,
  TEXT_GOT_A_QUESTION,
  TEXT_HAVE_MORE_QUESTION,
  TEXT_OR,
  TEXT_PATTAYA,
} from "../../utils/useConstants";
import { useIsMobile } from "../../utils/useIsMobile";
import {
  STYLE_BODY_3_REGULAR,
  STYLE_HEADING_2,
  STYLE_LINK_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_READING,
  STYLE_UNDERLINE_BLUE_24_16,
} from "../../utils/useStyle";
import { FaqFirstLoad } from "./functions/Faq.FirstLoad";
import FaqBanner from "./render/Faq.Banner";
import FaqList from "./render/Faq.List";
import MetaTags from "../../utils/useMetaTags";

const HeadDescription = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);

  return (
    <div className={` my-[40px] md:mt-10.7  ${STYLE_PADDING_READING}`}>
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {TEXT_GOT_A_QUESTION[language]}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      {isMobile ? (
        <div>
          <div className={` text-center ${STYLE_BODY_3_REGULAR(language)}`}>
            {TEXT_FAQ_HAVE_MORE_QUESTIONS[language]}
            {TEXT_FAQ_HAVE_MORE_QUESTIONS_BKK[language]}
            {language === "EN" ? (
              <span>
                {TEXT_BANGKOK[language]}
                {TEXT_AND_WORD[language]}
                <div>
                  {TEXT_PATTAYA[language]}
                  {TEXT_HAVE_MORE_QUESTION[language]}
                </div>
              </span>
            ) : (
              <span>
                {TEXT_BKK_AND_PTY[language]}
                <div>{TEXT_HAVE_MORE_QUESTION[language]}</div>
              </span>
            )}

            <div>
              <span
                onClick={() => navigate("/ContactUs")}
                className={`${STYLE_LINK_BLUE} cursor-pointer `}
              >
                {TEXT_CONTACT_US[language]}
              </span>
              {TEXT_OR[language]}
              <span
                onClick={() => {
                  navigate("/OurServices");
                }}
                className={`${STYLE_LINK_BLUE} cursor-pointer`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW_2[language]}
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className={` text-center ${STYLE_BODY_3_REGULAR(language)}`}>
            {TEXT_FAQ_HAVE_MORE_QUESTIONS[language]}
            {TEXT_FAQ_HAVE_MORE_QUESTIONS_BKK[language]}
            {TEXT_BKK_AND_PTY[language]}
            {language === "EN" ? (
              <span>
                {TEXT_HAVE_MORE_QUESTION[language]}
                <span
                  onClick={() => navigate("/ContactUs")}
                  className={`${STYLE_LINK_BLUE} cursor-pointer `}
                >
                  {TEXT_CONTACT_US[language]}
                </span>
                {TEXT_OR[language]}
                <span
                  onClick={() => {
                    navigate("/OurServices");
                  }}
                  className={`${STYLE_LINK_BLUE} cursor-pointer`}
                >
                  {TEXT_CREATE[language]}
                </span>
                {TEXT_AN_ORDER_NOW_2[language]}
              </span>
            ) : (
              <div>
                {TEXT_HAVE_MORE_QUESTION[language]}
                <span
                  onClick={() => navigate("/ContactUs")}
                  className={`${STYLE_LINK_BLUE} cursor-pointer `}
                >
                  {TEXT_CONTACT_US[language]}
                </span>
                {TEXT_OR[language]}
                <span
                  onClick={() => {
                    navigate("/OurServices");
                  }}
                  className={`${STYLE_LINK_BLUE} cursor-pointer`}
                >
                  {TEXT_CREATE[language]}
                </span>
                {TEXT_AN_ORDER_NOW_2[language]}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const FaqMain = () => {
  React.useEffect(() => {
    FaqFirstLoad();
  }, []);

  const { language } = React.useContext(ContextLanguage);

  return (
    <div id="scroll_faq">
      {language === "TH" ? (
        <MetaTags
          title="คำถามที่พบบ่อย - กรุงเทพ | My Laundry"
          description="เช็คดูคำถามที่พบบ่อยเกี่ยวกับร้านซักอบรีดและทำความสะอาดรองเท้า My Laundry ในกรุงเทพ! ค้นหาคำตอบ สั่งออเดอร์ตอนนี้เลย!"
        />
      ) : (
        <MetaTags
          title="FAQ - Bangkok | My Laundry"
          description="Check out our FAQ page for answers to your most frequently asked questions about our laundry, ironing & shoe cleaning services in Bangkok! Discover now!"
        />
      )}

      <FaqBanner />
      <div className={`${STYLE_MAX_WIDTH_DESKTOP}`}>
        <HeadDescription />
        <FaqList />
      </div>
    </div>
  );
};

export default FaqMain;
